<template>
  <p class="no-word-break">
    {{ t("billing.addPaymentMethod.description") }}
  </p>
  <p class="no-word-break mb-6">
    {{ t("billing.addPaymentMethod.termsLink1") }}
    <a href="https://yetipay.me/terms" target="_blank">{{
      t("billing.addPaymentMethod.termsText")
    }}</a>
    {{ t("billing.addPaymentMethod.termsLink2") }}
  </p>

  <StripePaymentWidget
    v-if="showPaymentWidget && merchantsStore.currentMerchant"
    :create-session="billingStore.createCheckoutSession"
    @error="onPaymentWidgetError"
  />
  <h2 v-else-if="paymentError">
    {{ paymentError }}
  </h2>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { useBillingStore } from "@/store/billing";
import { useMerchantsStore } from "@/store/merchants";

const { t } = useI18n();
const billingStore = useBillingStore();
const merchantsStore = useMerchantsStore();
const paymentError = ref("");
const customerHadValidPaymentMethod = ref(false);

const showPaymentWidget = computed(
  () => !customerHadValidPaymentMethod.value && !paymentError.value,
);
const onPaymentWidgetError = (error: { message: string }) => {
  console.log("payment widget error", error);
  paymentError.value = error.message || t("billing.addPaymentMethod.errorMessage");
};
</script>
